import { useContext, useEffect } from "react";
import { ImageLayerInterface } from "../types/images-layer";
import { VisualToggleContext } from "../context/modules/dimensions/VisualToggleContext";
import { VisualContext } from "../context/modules/dimensions/VisualContext";

const useImagesVisualToggle = (imagesLayer: ImageLayerInterface[] | null) => {
  const visualCtx = useContext(VisualContext);
  const visualToggleCtx = useContext(VisualToggleContext);

  useEffect(() => {
    if (!imagesLayer) return;

    imagesLayer!.forEach((imageLayer) => {
      imageLayer.imageRef.current?.opacity(0.5);
      imageLayer.imageRef?.current?.show();
    });

    const acodes = visualToggleCtx?.acodes;

    if (acodes?.length) {
      acodes?.forEach((acode) => {
        imagesLayer.forEach((imageLayer) => {
          if (imageLayer.vehicle.acode == acode) {
            imageLayer.imageRef.current?.hide();
          }
        });
      });
    }

    imagesLayer
      .filter(
        (imageLayer) => imageLayer.vehicle.acode == visualCtx?.vehicle?.acode
      )
      .forEach((imageLayer) => {
        imageLayer.imageRef.current?.opacity(1);
      });
  }, [visualToggleCtx?.acodes, imagesLayer]);
};

export default useImagesVisualToggle;
